<template>
    <div  style="overflow: auto;">
        <div id='doc' style="height:900px;"></div>
        <Loading :spinShow="show"></Loading>
    </div>
</template>
<script>
    import marked from 'marked';
    import katex from 'katex';
    import prismjs from 'prismjs';
    import 'prismjs/components/prism-python'
    import 'prismjs/components/prism-r.min'
    import {nbNotebook} from "../../../../../assets/js/nbv"
    import Loading from "@/components/common_components/loading/loading_view";
    export default {
        name:'notebook',
        props:{
            userCode:{
                type:String,
                required:true,
            },
            show:{
                type:Boolean,
                required:true,
            }
        },
        components:{
            Loading
        },
        created(){
            window.marked = marked;
            window.katex = katex;
        },
        watch:{
            userCode:(value)=>{
                if(value !== ''){
                    let doc = document.getElementById("doc");
                    nbNotebook.render(JSON.parse(value),doc);
                }
            }
        },
    }
</script>
